import { TeamInvitation } from '../models';
import { TeamRepository } from '../repositories';
import { SendNotificationUseCase } from './SendNotificationUseCase';

export class SendTeamInvitationUseCase {
  constructor(
    private teamRepository: TeamRepository,
    private sendNotification: SendNotificationUseCase,
  ) {}

  async execute(params: {
    teamId: string;
    inviterId: string;
    inviteeId: string;
    message?: string;
    teamName: string;
    inviterName: string;
  }): Promise<TeamInvitation> {
    const { teamId, inviterId, inviteeId, message, teamName, inviterName } = params;

    // Check invitee is not already a member
    const members = await this.teamRepository.getMembers(teamId);
    if (members.some((m) => m.userId === inviteeId)) {
      throw new Error('User is already a member of this team');
    }

    // Check no pending invitation already exists
    const sentInvitations = await this.teamRepository.getInvitationsSent(inviterId);
    const alreadyPending = sentInvitations.some(
      (i) => i.teamId === teamId && i.inviteeId === inviteeId && i.status === 'pending',
    );
    if (alreadyPending) {
      throw new Error('An invitation for this user is already pending');
    }

    const invitation = await this.teamRepository.sendInvitation(teamId, inviterId, inviteeId, message);

    // Send push notification to invitee
    try {
      await this.sendNotification.execute(
        inviteeId,
        'team_invitation',
        `Team invitation: ${teamName}`,
        `${inviterName} has invited you to join ${teamName}`,
        { teamId, teamName, inviterId },
      );
    } catch {
      // Notification failure should not block invitation creation
    }

    return invitation;
  }
}
